import request from '@/utils/request'


// 查询发现板块-举报类型配置列表
export function listDiscoveryReportType(query) {
  return request({
    url: '/discovery/discovery/report/type/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现板块-举报类型配置分页
export function pageDiscoveryReportType(query) {
  return request({
    url: '/discovery/discovery/report/type/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现板块-举报类型配置详细
export function getDiscoveryReportType(data) {
  return request({
    url: '/discovery/discovery/report/type/detail',
    method: 'get',
    params: data
  })
}

// 新增发现板块-举报类型配置
export function addDiscoveryReportType(data) {
  return request({
    url: '/discovery/discovery/report/type/add',
    method: 'post',
    data: data
  })
}

// 修改发现板块-举报类型配置
export function updateDiscoveryReportType(data) {
  return request({
    url: '/discovery/discovery/report/type/edit',
    method: 'post',
    data: data
  })
}

// 删除发现板块-举报类型配置
export function delDiscoveryReportType(data) {
  return request({
    url: '/discovery/discovery/report/type/delete',
    method: 'post',
    data: data
  })
}
